/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * PreUnlink phase
 */
export type PreUnlinkPhaseEnum = 'PRE_DELETE_SDDCS' | 'POST_DELETE_SDDCS';

export const PreUnlinkPhaseEnum = {

    PRE_DELETE_SDDCS: 'PRE_DELETE_SDDCS' as PreUnlinkPhaseEnum,

    POST_DELETE_SDDCS: 'POST_DELETE_SDDCS' as PreUnlinkPhaseEnum
};

